import {useEffect, useState} from "react";
import {baseApi} from "../../api/axios";
import LoadingComponent from "../Loading/LoadingComponent";
import {useAuthStore} from "../../store/user-store";
import {toast} from "react-toastify";
import {Link} from "react-router-dom";

export default function BanksList() {

    const [loading, setLoading] = useState(false)
    const [loadingSubmit, setLoadingSubmit] = useState(false)
    const [errorImage, setErrorImage] = useState('')
    const [errorAmount, setErrorAmount] = useState('')
    const [banks, setBanks] = useState([])
    const [banksFilter, setBanksFilter] = useState([])
    const [search, setSearch] = useState('')
    const [bank, setBank] = useState({})
    const [amount, setAmount] = useState(0)
    const [info, setInfo] = useState('')
    const [image, setImage] = useState(0)
    const [imagePreview, setImagePreview] = useState(null);
    const authStore = useAuthStore();
    const onSubmit = async () => {
        setLoadingSubmit(true)
        if (!image) {
            setErrorImage('يرجى تحديد صورة الإشعار')
            return;
        }

        if (parseFloat(amount) <= 0) {
            setErrorAmount('يرجى إدخال القيمة')
            return;
        }

        const formData = new FormData();
        formData.append('amount', amount);
        formData.append('img', image);
        formData.append('bank_id', bank?.id);
        formData.append('info', info);
        try {
            var response = await baseApi.post('/charges', formData);
            toast.success('تم إرسال الطلب بنجاح')
        } catch (e) {
        }
        setLoadingSubmit(false)
    }
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImage(file);
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        } else {
            setImage(null);
            setImagePreview(null);
        }
    }
    const searchBank = (text) => {
        if (text == '') {
            setBanksFilter(banks)
        } else {
            setBanksFilter(
                banks.filter(bank => bank.name.toLowerCase().includes(text.toLowerCase()))
            )
        }
    }

    useEffect(() => {
        getBanks()
    }, [])

    const getBanks = async () => {
        setLoading(true)
        try {
            var res = await baseApi('/banks');

            if (res.data?.banks != null) {
                setBanks(res.data?.banks)
                setBanksFilter(res.data?.banks)
            }
            console.log(res.data);
        } catch (e) {

        }
        setLoading(false)
    }

    return <div className={'container'}>
        <div className="row justify-content-center">
            <div className="col-md-12 p-3 text-center">
                {loading === false && banks.length === 0 ?
                    <h3 className={'alert alert-danger'}>لا يوجد طرق دفع</h3> : null}
                {loading === true ? <LoadingComponent/> : null}
                <div className="row justify-content-center">
                  <div className="col-md-6">
                      <input type="text" className={'form-input rounded'} onChange={(e)=>searchBank(e.target.value)} placeholder={'بحث'}/>
                  </div>


                </div>
            </div>
            <div className="col-12">
                <div className="row">
                    {banksFilter.length > 0 ? banksFilter.map((b) => {
                        return (
                            <div className="col-4 col-md-2" key={b.id}>
                                <Link  to={`/payments/${b.id}`}>
                                <div
                                     className={`d-flex flex-column justify-content-center align-items-center bank m-2 ${bank?.id === b.id ? 'active' : ''}`}>
                                    <img className={'img-bank'} src={`${b.img}`} alt=""/>
                                    <span className={'title-bank'}>{b.name}</span>
                                </div>
                                </Link>
                            </div>
                        )
                    }) : null}

                </div>
            </div>

        </div>
    </div>
}